import { http } from '@/lib/http';
import type { ListQuery, Page } from '@/types/common';
import type {
  PlatformWarehouse,
  PlatformWarehouseCreatePayload,
} from '@/types/platform';

const BASE = '/api/v1/platform/warehouses';

export interface PlatformWarehouseListQuery extends ListQuery {
  tenantId?: string;
  organizationId?: string;
}

// H1 — plan-gated warehouse quota for the calling tenant.
export interface WarehouseQuota {
  used: number;
  /** null = unlimited (Enterprise / Custom plans). */
  max: number | null;
  planSlug: string;
  planName: string;
  atLimit: boolean;
}

export const platformWarehousesService = {
  list: (query: PlatformWarehouseListQuery = {}) =>
    http.get<Page<PlatformWarehouse>>(BASE, { params: query }),
  get: (id: string) => http.get<PlatformWarehouse>(`${BASE}/${id}`),
  create: (payload: PlatformWarehouseCreatePayload) =>
    http.post<PlatformWarehouse, PlatformWarehouseCreatePayload>(BASE, payload),
  update: (id: string, payload: Partial<PlatformWarehouseCreatePayload>) =>
    http.patch<PlatformWarehouse, Partial<PlatformWarehouseCreatePayload>>(`${BASE}/${id}`, payload),
  quota: () => http.get<WarehouseQuota>(`${BASE}/quota`),
};
